<template>
    <div class="p-5">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div class="c-title">Donations - {{ designation_name }}</div>
            <div class="ml-3">
                <button @click="goBack" class="btn c-cancel-btn">Back</button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead class="c-thead">
                    <tr>
                        <th scope="col" style="cursor: pointer"
                            class="h-name"
                            @click="onSort(SORT_ITEMS.name)"
                        >
                            Full name
                            <span class="ml-2" v-if="currentSortBy === SORT_ITEMS.name">
                                <i :class="currentSortOrder === SORT_ORDER.asc ? 'fa-chevron-up' : 'fa-chevron-down'"
                                    class="fa mt-2" style="font-size: 14px;"></i>
                            </span>
                        </th>
                        <th scope="col" class="h-phone">Phone</th>
                        <th scope="col" class="h-email">Email</th>
                        <th scope="col" style="cursor:pointer;"
                            class="h-date"
                            @click="onSort(SORT_ITEMS.date)"
                        >
                            Date
                            <span class="ml-2" v-if="currentSortBy === SORT_ITEMS.date">
                                <i :class="currentSortOrder === SORT_ORDER.asc ? 'fa-chevron-up' : 'fa-chevron-down'"
                                   class="fa mt-2" style="font-size: 14px;"></i>
                            </span>
                        </th>
                        <th scope="col"
                            class="h-amount"
                            style="cursor:pointer;"
                            @click="onSort(SORT_ITEMS.amount)"
                        >
                            Amount
                            <span class="ml-2" v-if="currentSortBy === SORT_ITEMS.amount">
                                <i :class="currentSortOrder === SORT_ORDER.asc ? 'fa-chevron-up' : 'fa-chevron-down'"
                                   class="fa mt-2" style="font-size: 14px;"></i>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="donations.length">
                    <TableItem
                        v-for="item in donations"
                        :key="item.donation_id"
                        :data="item"
                        @openDonationDetails="openDonationDetails"
                    />
                </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">No data</td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center" v-if="totalPage > 1">
              <CustomPagination :activePage="currentPage" :totalPage="totalPage" @paginationHandle="onClickPagging"></CustomPagination>
            </div>
            <modal-donation-details v-if="isShowDonationModal" :data="modalData" @close="isShowDonationModal = false" />
        </div>
    </div>
</template>

<script>
import TableItem from '../campaigns/components/DonationTableItem.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import CustomPagination from "@/commons/CustomPagination/CustomPagination.vue";
import ModalDonationDetails
    from "@/components/campaigns/components/ModalDonationDetails.vue";
import {EventBus} from "@/utils/event-bus";

const SORT_ITEMS = {
  name: 1,
  date: 2,
  amount: 3,
};
const SORT_ORDER = {
  asc: 1,
  desc: -1,
};

export default {
    name: 'DesignationDonations',
    components: {
        CustomPagination,
        TableItem,
        ModalDonationDetails,
    },
    data() {
        return {
            designation_name: '',
            search: '',
            SORT_ITEMS,
            SORT_ORDER,
            donations: [],
            totalPage: 0,
            currentPage: 1,
            currentSortBy: SORT_ITEMS.date,
            currentSortOrder: SORT_ORDER.desc,
            isShowDonationModal: false,
            modalData: null,
        };
    },
    methods: {
        onSort(value) {
            if (value === this.currentSortBy) {
                this.currentSortOrder = this.SORT_ORDER.asc === this.currentSortOrder ? this.SORT_ORDER.desc : this.SORT_ORDER.asc;
            } else {
                this.currentSortBy = value;
                this.currentSortOrder = SORT_ORDER.desc;
            }

            this.totalPage = 0;
            this.getDonations(0);
        },
        goBack() {
            this.$router.push({
                name: 'Designations',
            });
        },
        getDonations(page = 0) {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.designationGetDonations,
                designation_id: this.$route.params.id,
                page,
                sort_by: this.currentSortBy,
                sort_order: this.currentSortOrder,
                search_string: this.search,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    if (page === 0) {
                      this.totalPage = response.num_of_pages;
                      this.currentPage = 1;
                    }
                    this.donations = response.donations;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        onClickPagging(page) {
            this.currentPage = page.pageIndex;
            this.getDonations(page.pageIndex - 1);
        },
        openDonationDetails(data) {
            this.$router.push({
                'name': 'DonationView',
                params: {
                    id: data.donation_id,
                },
            })
        }
    },
    created() {
        this.getDonations();
        EventBus.$on('searchDesignationDonations', (search) => {
            this.search = search;
            this.getDonations();
        });

        if (this.$route?.params?.name) {
            this.designation_name = this.$route.params.name;
        }
    },
};
</script>

<style lang="scss" scoped>
.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-thead {
    th {
        color: #41B8DC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-name {
            width: 25%;
        }
        &.h-phone {
            width: 15%;
        }
        &.h-email {
            width: 20%;
        }
        &.h-date {
            width: 20%;
        }
        &.h-amount {
            width: 20%;
        }
    }
}
</style>
